export enum RouteName {
  List = 'manage-merchant-country-configuration-list',
}
